import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { EventTemplatesDataResolver } from '../../../resolvers/event-template-data.resolver';
import { TemplatesCreateFlexpayCreateControllerModule } from './controllers/TemplatesCreateFlexpayCreateController';
import { TemplatesCreateFlexpayCreateScheduleView } from './schedule/schedule';

export const TemplatesCreateFlexpayCreateView = angular
  .module('acme.view.application.templates.create.flexpay.create', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    TemplatesCreateFlexpayCreateControllerModule,
    TemplatesCreateFlexpayCreateScheduleView,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.templates.create.flexpay.create',
      url: '/create',
      abstract: true,
      views: {
        'subview-main@application.templates': {
          controller: 'TemplatesCreateFlexpayCreateController',
          templateUrl: 'views/application/views/templates/create/flexpay/create/create.tpl.html',
        },
      },
    });

    $stateProvider.state({
      name: 'application.templates.edit.flexpay.create',
      url: '/create',
      abstract: true,
      views: {
        'subview-main@application.templates': {
          controller: 'TemplatesCreateFlexpayCreateController',
          templateUrl: 'views/application/views/templates/create/flexpay/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: '    ',
      },
      resolve: {
        EventTemplateData: EventTemplatesDataResolver({ noCache: true }),
      },
    });

    $stateProvider.state({
      name: 'application.templates.edit.flexpay.edit',
      url: '/edit',
      abstract: true,
      views: {
        'subview-main@application.templates': {
          controller: 'TemplatesCreateFlexpayCreateController',
          templateUrl: 'views/application/views/templates/create/flexpay/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: '    ',
      },
      resolve: {
        EventTemplateData: EventTemplatesDataResolver({ noCache: true }),
      },
    });
  }).name;
